import { Divider, Form, Typography, VertButton, VertDatePicker, VertLoading, VertSelect, VertTypography, notification } from '@vertem-core/vertice-ds';
import React, { useEffect, useMemo, useState } from 'react';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getAddressThunk } from 'redux/Reducers/Concierge/addressSlicer';
import PropTypes from 'prop-types';
import { formatCEP, formatDocument } from 'Utils/format';

import { SolicitationAddressInitialState } from 'Constants/Concierge/initialStateValues';

const Delivery = ({ ...props }) => {
    const {
        solicitation,
        setSolicitation,
        handleNextStep,
        handlePreviousStep
    } = props;

    const [form] = Form.useForm();

    const [billingAddress, setBillingAddress] = useState(SolicitationAddressInitialState);
    const [deliveryAddress, setDeliveryAddress] = useState(SolicitationAddressInitialState);

    const dispatch = useDispatch();

    const {
        dataAddress,
        loadingAddress,
    } = useSelector(
        (state) => state.AddressSlicer
    );

    const billingAddressList = useMemo(() => {
        if (!dataAddress) return [];
        return dataAddress.map((billingAddress, i) => {
            return {
                name: billingAddress.name,
                document: billingAddress.document,
                street: billingAddress.street,
                district: billingAddress.district,
                city: billingAddress.city,
                number: billingAddress.number,
                reference: billingAddress.reference,
                state: billingAddress.state,
                zipCode: billingAddress.zipCode,
                isMultipleAddress: billingAddress.isMultipleAddress,
                label: billingAddress.isMultipleAddress ? billingAddress.name : billingAddress.street,
                value: i,
            };
        });
    }, [dataAddress]);

    const handleBillingAddress = (billingAddressObject) => {
        setBillingAddress(billingAddressObject);
        setSolicitation((solicitation) => ({
            ...solicitation,
            billingAddress: billingAddressObject
        }))
    }

    const deliveryAddressList = useMemo(() => {
        if (!dataAddress) return [];
        return dataAddress.map((deliveryAddress, i) => {
            return {
                name: deliveryAddress.name,
                document: deliveryAddress.document,
                street: deliveryAddress.street,
                district: deliveryAddress.district,
                city: deliveryAddress.city,
                number: deliveryAddress.number,
                reference: deliveryAddress.reference,
                state: deliveryAddress.state,
                zipCode: deliveryAddress.zipCode,
                isMultipleAddress: deliveryAddress.isMultipleAddress,
                label: deliveryAddress.isMultipleAddress ? deliveryAddress.name : deliveryAddress.street,
                value: i,
            };
        });
    }, [dataAddress]);

    const handleDeliveryAddress = (deliveryAddressObject) => {
        setDeliveryAddress(deliveryAddressObject)
        setSolicitation((solicitation) => ({
            ...solicitation,
            deliveryAddress: deliveryAddressObject
        }))
    }

    const disableContinueButton = () => {
        if (solicitation.isBillPayment && !solicitation.billingAddress)
            return true;

        if (!solicitation.isBillPayment && (!solicitation.billingAddress || !solicitation.deliveryAddress))
            return true;

        return false;
    }

    useEffect(() => {
        if (!dataAddress) return;

        if (dataAddress.length === 1) {
            const sharedAddr = billingAddressList.find(addr => addr.street === dataAddress[0].street);

            handleBillingAddress(sharedAddr);
            handleDeliveryAddress(sharedAddr);
        }
    }, [dataAddress]);

    const continueStep = () => {
        handleNextStep(solicitation);
    }

    useEffect(() => {
        dispatch(getAddressThunk(solicitation.participantId));

        if (solicitation.deliveryAddress) {
            const deliveryAddress = {
                ...solicitation.deliveryAddress,
                label: solicitation.deliveryAddress.name
            };

            setDeliveryAddress(deliveryAddress);
        }
        else {
            setDeliveryAddress(SolicitationAddressInitialState);
        }

        if (solicitation.billingAddress) {
            const billingAddress = {
                ...solicitation.billingAddress,
                label: solicitation.billingAddress.name
            };

            setBillingAddress(billingAddress);
        }
        else {
            setBillingAddress(SolicitationAddressInitialState);
        }
    }, []);

    return (
        <>
            {
                <Form form={form}>

                    <Row className='container-concierge-information-main' >
                        {loadingAddress ?
                            <VertLoading className='loading-space' />
                            :
                            <>
                                <Col span={24}>
                                    <Typography.Text className='text-subtitle'>
                                        Endereço de Faturamento
                                    </Typography.Text>
                                </Col>

                                <Col span={24}>
                                    <Form.Item className='form-items'>
                                        <VertSelect
                                            showSearch
                                            options={billingAddressList}
                                            filterOption={(input, option) => {
                                                return (
                                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                );
                                            }}
                                            onSelect={(_, billingAddressObject) => handleBillingAddress(billingAddressObject)}
                                            value={solicitation.billingAddress}
                                            loading={loadingAddress}
                                            placeholder='Selecionar'
                                            notFoundContent={
                                                <VertTypography.Text>
                                                    Sem resultados
                                                </VertTypography.Text>
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                                {billingAddress.zipCode !== '' &&
                                    <Col span={24} className='card-address' >
                                        <Col>
                                            <Typography.Text strong>
                                                Nome:
                                            </Typography.Text>
                                            <Typography.Text className='margin-left-divider' >
                                                {billingAddress.name || "Endereço de Faturamento"}
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>
                                                Documento:
                                            </Typography.Text>
                                            <Typography.Text className='margin-left-divider' >
                                                {!!billingAddress.document
                                                    ? formatDocument(billingAddress.document)
                                                    : formatDocument(solicitation.clientDocument)}
                                            </Typography.Text>
                                        </Col>
                                        <Divider />
                                        <Col>
                                            <Typography.Text strong>
                                                CEP:
                                            </Typography.Text>
                                            <Typography.Text className='margin-left-divider' >
                                                {formatCEP(billingAddress.zipCode)}
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>
                                                Endereço:
                                            </Typography.Text>
                                            <Typography.Text className='margin-left-divider' >
                                                {`${billingAddress.street ?? ''}, ${billingAddress.number ?? ''} ${billingAddress?.complement ?? ''}`}
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>
                                                Bairro:
                                            </Typography.Text>
                                            <Typography.Text className='margin-left-divider' >
                                                {billingAddress.district}
                                            </Typography.Text>
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>
                                                Cidade
                                            </Typography.Text>
                                            <Typography.Text className='margin-left-divider' >
                                                {`${billingAddress.city} - ${billingAddress.state}`}
                                            </Typography.Text>
                                        </Col>
                                    </Col>
                                }

                                {
                                    !solicitation.isBillPayment &&
                                    <>

                                        <Col span={24}>
                                            <Typography.Text className='text-subtitle'>
                                                Endereço de Entrega
                                            </Typography.Text>
                                        </Col>

                                        <Col span={24}>
                                            <Form.Item className='form-items'>
                                                <VertSelect
                                                    showSearch
                                                    options={deliveryAddressList}
                                                    filterOption={(input, option) => {
                                                        return (
                                                            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        );
                                                    }}
                                                    onSelect={(_, deliveryAddressObject) => handleDeliveryAddress(deliveryAddressObject)}
                                                    value={solicitation.deliveryAddress}
                                                    loading={loadingAddress}
                                                    placeholder='Selecionar'
                                                    notFoundContent={
                                                        <VertTypography.Text>
                                                            Sem resultados
                                                        </VertTypography.Text>
                                                    }
                                                />
                                            </Form.Item>
                                        </Col>

                                        {deliveryAddress.zipCode !== '' &&
                                            <Col span={24} className='card-address' >
                                                <Col>
                                                    <Typography.Text strong>
                                                        Nome:
                                                    </Typography.Text>
                                                    <Typography.Text className='margin-left-divider' >
                                                        {deliveryAddress.name || "Endereço de Entrega"}
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text strong>
                                                        Documento:
                                                    </Typography.Text>
                                                    <Typography.Text className='margin-left-divider' >
                                                        {!!deliveryAddress.document
                                                            ? formatDocument(deliveryAddress.document)
                                                            : formatDocument(solicitation.clientDocument)}
                                                    </Typography.Text>
                                                </Col>
                                                <Divider />
                                                <Col>
                                                    <Typography.Text strong>
                                                        CEP:
                                                    </Typography.Text>
                                                    <Typography.Text className='margin-left-divider' >
                                                        {formatCEP(deliveryAddress.zipCode)}
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text strong>
                                                        Endereço:
                                                    </Typography.Text>
                                                    <Typography.Text className='margin-left-divider' >
                                                        {`${deliveryAddress.street ?? ''}, ${deliveryAddress.number ?? ''} ${deliveryAddress?.complement ?? ''}`}
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text strong>
                                                        Bairro:
                                                    </Typography.Text>
                                                    <Typography.Text className='margin-left-divider' >
                                                        {deliveryAddress.district}
                                                    </Typography.Text>
                                                </Col>
                                                <Col>
                                                    <Typography.Text strong>
                                                        Cidade:
                                                    </Typography.Text>
                                                    <Typography.Text className='margin-left-divider' >
                                                        {`${deliveryAddress.city} - ${deliveryAddress.state}`}
                                                    </Typography.Text>
                                                </Col>
                                            </Col>
                                        }
                                    </>
                                }
                            </>
                        }
                    </Row >

                    <Row gutter={[8, 8]} justify={'end'}>
                        <Col className='collum-btn-concierge'>
                            <VertButton
                                className='button-continue button-concierge'
                                type='default'
                                size="default"
                                onClick={() => handlePreviousStep()}
                            >
                                <Typography.Text className='span-button-return'>
                                    Voltar
                                </Typography.Text>

                            </VertButton>
                        </Col>
                        <Col className='collum-btn-concierge'>
                            <VertButton
                                htmlType="submit"
                                className='button-continue button-concierge'
                                type='highlight'
                                size="default"
                                disabled={disableContinueButton()}
                                onClick={continueStep}
                            >
                                <Typography.Text className='span-button-continue'>
                                    Continuar
                                </Typography.Text>

                            </VertButton>
                        </Col>
                    </Row>
                </Form >
            }
        </>
    )
}

Delivery.propTypes = {
    solicitation: PropTypes.object.isRequired,
    setSolicitation: PropTypes.func.isRequired,
    handleNextStep: PropTypes.func.isRequired,
    handlePreviousStep: PropTypes.func.isRequired,
};


export default Delivery;
